// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { getUnitListPrice, getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mergeWithCss } from "@keller/XDL/Utilities";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    productContext: ProductContextModel;
    extendedStyles?: TypographyPresentationProps;
}

const productOriginallyStyles: TypographyPresentationProps = {
    size: 12,
    weight: "normal",
    color: "common.ui6",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
        s {
            font-weight: bold;
        }
        display: inline-block;
    `,
};

const ProductOriginally: FC<OwnProps> = ({ productContext, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(productOriginallyStyles, extendedStyles));

    const pricing = productContext.productInfo.pricing;
    const qtyOrdered = productContext.productInfo.qtyOrdered || 1;

    if (!pricing || productContext.product.isVariantParent) {
        return null;
    }

    const { price: unitNetPrice } = getUnitNetPrice(pricing, qtyOrdered || 1); // regular price
    const { price: unitListPrice, priceDisplay } = getUnitListPrice(pricing, qtyOrdered || 1); // originalPrice

    if (unitNetPrice >= unitListPrice) {
        return null;
    }

    return (
        <Typography {...styles} data-test-selector="ProductOriginally">
            {translate("Originally")}: <Typography as="s">{priceDisplay}</Typography>
        </Typography>
    );
};

export default ProductOriginally;
